import { WidgetPage } from '@/common/model/recommend/widgetPage'

export const WidgetPageApiPath = {
  LIST_WIDGET_PAGES: '/api/sites/{site_id}/widget-pages', // GET List
  GET_WIDGET_PAGE: '/api/sites/{site_id}/widget-pages/{widget_page_id}', // GET Get
  CREATE_WIDGET_PAGE: '/api/sites/{site_id}/widget-pages', // POST Create
  UPDATE_WIDGET_PAGE: '/api/sites/{site_id}/widget-pages/{widget_page_id}', // PUT Update
  DELETE_WIDGET_PAGE: '/api/sites/{site_id}/widget-pages/{widget_page_id}' // DELETE Delete
}

export type WidgetPageApiPath = (typeof WidgetPageApiPath)[keyof typeof WidgetPageApiPath]

export interface ListWidgetPagesVars {
  site_id: number
}

export interface GetWidgetPageVars {
  site_id: number
  widget_page_id: number
}

export interface CreateWidgetPageVars {
  site_id: number
  name: string
  target_url?: string | null
  basic_auth_user?: string | null
  basic_auth_pass?: string | null
  ai_instructions?: string | null
}

export interface UpdateWidgetPageVars {
  site_id: number
  widget_page_id: number
  name?: string | null
  target_url?: string | null
  basic_auth_user?: string | null
  basic_auth_pass?: string | null
  ai_instructions?: string | null
}

export interface DeleteWidgetPageVars {
  site_id: number
  widget_page_id: number
}

export type ListWidgetPagesResponse = WidgetPage[]
export type GetWidgetPageResponse = WidgetPage
export type CreateWidgetPageResponse = WidgetPage
export type UpdateWidgetPageResponse = WidgetPage

export interface DeleteWidgetPageResponse {
  deleted: boolean
}
